import { isArrayLike } from '@kurtosys/ksys-app-template/dist/utils/isArrayLike';

/**
 * Determines whether to show a single document inline or not based on the configuration and the document group name.
 * @param showSingleDocumentConfig - The configuration for showing a single document. Can be a boolean, a string, an array of strings, or undefined.
 * @param documentGroupName - The name of the document group to check against the configuration.
 * @returns A boolean indicating whether to show a single document inline or not.
 */
export default function getShowSingleDocument(
    showSingleDocumentConfig: boolean | string | Array<string> | undefined,
    documentGroupName: string
): boolean | undefined {
    let showSingleDocument;
    if (
        typeof showSingleDocumentConfig !== 'boolean' &&
        typeof showSingleDocumentConfig !== 'string' &&
        isArrayLike(showSingleDocumentConfig as Array<string>)
    ) {
        showSingleDocument =
            (showSingleDocumentConfig as Array<string>).indexOf(
                documentGroupName
            ) >= 0;
    } else if (showSingleDocumentConfig !== undefined) {
        showSingleDocument = showSingleDocumentConfig;
    }
    return showSingleDocument;
}



// WEBPACK FOOTER //
// ./src/utils/getShowSingleDocument.ts